var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossDisabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10177"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 356",
    x1: 1.35355,
    y1: 0.646447,
    x2: 16.3536,
    y2: 15.6464,
    stroke: "rgba(148,139,158,0.459)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 357",
    y1: -0.5,
    x2: 21.2132,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 16 1)",
    stroke: "rgba(148,139,158,0.459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossDisabledIcon);
export default __webpack_public_path__ + "static/media/cross-disabled-icon.0cad9289c12f65d98697bd41e219270b.svg";
export { ForwardRef as ReactComponent };